module.exports = __webpack_public_path__ + "static/media/3.4b02bc7e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/projects/lumen/3.jpg
// module id = 504
// module chunks = 0